import { render, staticRenderFns } from "./view04.vue?vue&type=template&id=21d3eeaa&scoped=true"
import script from "./view04.vue?vue&type=script&lang=js"
export * from "./view04.vue?vue&type=script&lang=js"
import style0 from "./view04.vue?vue&type=style&index=0&id=21d3eeaa&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d3eeaa",
  null
  
)

export default component.exports